import $ from 'helper/jquery';
import { Foundation } from 'foundation-sites';

import '@fortawesome/fontawesome-free/css/all';

import { breakpoint, pageUrl } from 'helper/clientDetails';

import { Turbo } from '@hotwired/turbo-rails';

// Disable Turbo Drive; we need some preparation for it to become enabled everywhere.
// Caveat: If disabling Turbo Drive by default, `button_to` links will only work with Turbo,
// iff the form has ´data: { turbo: true }´
Turbo.session.drive = false;

// TODO: this has to go!
Foundation.addToJquery($);
$(document).foundation();

window.addEventListener('load', () => {
  // Set user's timezone as cookie to fallback detect if not set in settings
  const date = new Date();
  date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000)); // 365d
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `browser.timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}; ${expires}; path=/; SameSite=LAX`;
});

// Collect generic client details
function collectClientDetails() {
  const screenSize = breakpoint(window.screen.width);
  const windowSize = breakpoint(window.innerWidth);

  // eslint-disable-next-line no-undef
  plausible('pageview', { u: pageUrl(), props: { screen_size: screenSize, window_size: windowSize } });
}

window.plausible = window.plausible || function (...args) {
  (window.plausible.q = window.plausible.q || []).push(args);
};
document.addEventListener('DOMContentLoaded', collectClientDetails);
